module.exports = __webpack_public_path__ + "static/img/cstp1.c89d9f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/joinus/cstp1.png
// module id = Z0y2
// module chunks = 1